<vnm-content-header [header]="theme.name" [info]="theme.description">
  <ng-template #contentActions>
    <button
      pButton
      *ngIf="!isActiveTheme()"
      [label]="'theme-details.apply-theme' | translate"
      (click)="applyTheme()"
    ></button>
    <button pButton [label]="'theme-details.save-theme' | translate" (click)="saveTheme()"></button>
  </ng-template>
</vnm-content-header>
<div class="content-body" [vnmTheme]="theme">
  <vnm-grid>
    <p-card [header]="'theme-details.colors.header' | translate" [subheader]="'theme-details.colors.info' | translate">
      <hr />
      <form #propertyForm="ngForm" class="p-form">
        <ng-template ngFor let-property [ngForOf]="themeProperties">
          <vnm-form-field [label]="property">
            <vnm-color-picker [(ngModel)]="theme.properties[property]" [name]="property"></vnm-color-picker>
          </vnm-form-field>
        </ng-template>
      </form>
    </p-card>
    <p-card header="Buttons">
      <div class="p-column">
        <div class="p-block">
          <button pButton label="Click"></button>
        </div>
        <div class="p-block">
          <button pButton icon="fa fa-check" label="Click"></button>
        </div>
        <div class="p-block">
          <button pButton icon="fa fa-check" iconPos="right" label="Click"></button>
        </div>
        <div class="p-block">
          <button pButton icon="fa fa-check"></button>
        </div>
        <div class="p-block">
          <button pButton icon="fa fa-check" [disabled]="true" label="Disabled"></button>
        </div>
      </div>
    </p-card>
  </vnm-grid>
</div>
